import { Flex } from "antd"

import MobilePagination from "../../../../Components/MobilePagination/MobilePagination"
import EmptyLookups from "../EmptyStates/EmptyLookups"
import ReceiptLookupCard from "./ReceiptLookupCard"
import ReceiptLookupCardSkeleton from "./ReceiptLookupCardSkeleton"

import styles from "./styles.module.less"

const SKELETON_COUNT = 20

export const ReceiptLookupList = ({
  loading,
  data,
  totalCount,
  page,
  pageSize,
  onChangePage,
  withOutPagination,
  skeletonCount = SKELETON_COUNT
}) => {
  if (loading) {
    return (
      <div className={styles.grid}>
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <ReceiptLookupCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (!data?.length) {
    return <EmptyLookups />
  }

  return (
    <Flex vertical gap={16}>
      <div className={styles.grid}>
        {data.map((row) => (
          <ReceiptLookupCard key={row.id} record={row} />
        ))}
      </div>
      {!withOutPagination && totalCount > pageSize && (
        <MobilePagination
          current={page}
          pageSize={pageSize}
          total={totalCount}
          onChange={onChangePage}
        />
      )}
    </Flex>
  )
}
